// SPDX-FileCopyrightText: 2026 Dusan Mijatovic (Netherlands eScience Center)
// SPDX-FileCopyrightText: 2026 Netherlands eScience Center
//
// SPDX-License-Identifier: Apache-2.0

import Link from 'next/link'

import {ssrSoftwareUrl} from '~/utils/postgrestUrl'

type KeywordBoxProps = {
  label: string
}

export default function KeywordBox({label}: KeywordBoxProps) {
  const url = ssrSoftwareUrl({keywords: [label]})
  return (
    <div className="bg-base-200 hover:bg-base-300 text-base-content p-3 text-center rounded-lg transition-colors shadow-sm">
      <div className="text-lg font-medium">
        <Link href={url} className="hover:underline">
          {label}
        </Link>
      </div>
    </div>
  )
}
